import { render, staticRenderFns } from "./CourseGroupCard.vue?vue&type=template&id=abe52852&scoped=true&"
import script from "./CourseGroupCard.vue?vue&type=script&lang=js&"
export * from "./CourseGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseGroupCard.vue?vue&type=style&index=0&id=abe52852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe52852",
  null
  
)

export default component.exports